var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"testimonials"},[_c('hot-container',{staticClass:"testimonials__container"},[_c('h2',{staticClass:"testimonials__title",attrs:{"data-testid":"title"},domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('div',{staticClass:"testimonials__carousel-container",attrs:{"data-testid":"carousel"}},[_c('hot-carousel',{attrs:{"component":{
          is: _vm.card,
          items: _vm.items,
        },"swiper-options":_vm.swiperOptions}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }